/**
 * AddToProjectButton Component
 */

import { showAddTrackToProjectForm } from '../../../../redux/actions/ui';
import { makeIsTrackInProjects } from '../../../../redux/selectors/projects';
import './styles.scss';

import * as React from 'react';
import * as BEM from 'react-bem-helper';
import { connect, MapStateToProps } from 'react-redux';

import { IconProject, IconProjectSelected } from '../../images/Icon';
import Button, { ButtonProps } from '../Button';

interface IOwnStateProps {
  isTrackInProjects: boolean;
}

interface IOwnDispatchProps {
  addToProject(): void;
}

interface IOwnProps extends Pick<ButtonProps, 'className' | 'label' | 'onClick'> {
  trackId: string;
  trackVersion?: string;
  showIcon?: boolean;
}

type AddToProjectButtonProps = IOwnProps & IOwnStateProps & IOwnDispatchProps;

const classes = new BEM('add-to-project-button');

class AddToProjectButton extends React.Component<AddToProjectButtonProps, any> {
  static defaultProps: Partial<AddToProjectButtonProps> = {
    label: 'Save',
  };

  onClick: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    e.persist();

    if (this.props.onClick) {
      this.props.onClick(e);
    }

    this.props.addToProject();
  }

  render() {
    const {
      className,
      label,
    } = this.props;

    const icon = this.props.showIcon !== false &&
      (this.props.isTrackInProjects ? <IconProjectSelected /> : <IconProject />);
    return (
      <Button
        onClick={this.onClick}
        label={label!}
        icon={icon}
        {...classes('', '', className) }
      />
    );
  }
}

const makeMapStateToProps = () => {
  const isTrackInProjects = makeIsTrackInProjects();
  const mapStateToProps: MapStateToProps<IOwnStateProps, IOwnProps, IStoreState> =
    (state, props) => ({
      isTrackInProjects: isTrackInProjects(state, props),
    });

  return mapStateToProps;
};

const ConnectedAddToProjectButton = connect<IOwnStateProps, IOwnDispatchProps, IOwnProps, IStoreState>(
  makeMapStateToProps,
  (dispatch, { trackId, trackVersion }) => ({
    addToProject: () => dispatch(showAddTrackToProjectForm({ trackId, trackVersion: trackVersion || 'original' })),
  }),
)(AddToProjectButton);

export default ConnectedAddToProjectButton;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/atoms/buttons/AddToProjectButton/index.tsx